import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TenantRouterService } from '../services/tenant-router.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private tenantRouter: TenantRouterService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {

    // 1️⃣ Not authenticated → tenant login
    if (!this.authService.isAuthenticated()) {
      return this.tenantRouter.createUrlTree('login');
    }

    // 2️⃣ Role validation
    const expectedRoles = this.normalizeRoles(route.data['role']);
    const userRole = this.authService.getUserRole();

    if (expectedRoles.length && userRole && !expectedRoles.includes(userRole)) {
      // Authenticated but unauthorized → fallback dashboard
      return this.tenantRouter.createUrlTree(this.fallbackRoute(userRole));
    }

    return true;
  }

  /**
   * Normalize role metadata to array
   */
  private normalizeRoles(roleData: string | string[] | undefined): string[] {
    if (!roleData) return [];
    return Array.isArray(roleData) ? roleData : [roleData];
  }

  /**
   * Role-based fallback routes
   */
  private fallbackRoute(role: string | null): string {
    switch (role) {
      case 'hr':
        return 'hr-dashboard';
      case 'manager':
        return 'manager-dashboard';
      case 'user':
        return 'user-dashboard';
      default:
        return 'login';
    }
  }
}
